import React, { useRef } from "react";
import "./SquareGrid.css";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import { SendIcon } from "./icons";

interface MathInputProps {
  formulaRef: React.RefObject<HTMLInputElement>;
  newInput: (value: number) => void;
  updateFormula: () => void;
}

const MathInput: React.FC<MathInputProps> = ({
  formulaRef,
  newInput,
  updateFormula,
}) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const numberRef = useRef<HTMLInputElement | null>(null);

  function onEnter() {
    const raw = numberRef.current?.value ?? "250";
    const value = Number(raw);
    if (!Number.isNaN(value)) {
      newInput(value);
    }
  }

  return (
    <>
      <span>
        <TextField
          variant="standard"
          id="FormulaInput"
          label="Pattern"
          type="text"
          defaultValue={"4*n^2 - 4*n + 1"}
          inputRef={formulaRef}
          onKeyDown={(ev) => {
            if (ev.key === "Enter") {
              buttonRef.current?.click();
              ev.preventDefault();
            }
          }}
          onChange={updateFormula}
        />
      </span>
      <span>
        <TextField
          variant="standard"
          id="SquaresInput"
          label="Squares"
          type="number"
          defaultValue={250}
          inputRef={numberRef}
          onKeyDown={(ev) => {
            if (ev.key === "Enter") {
              buttonRef.current?.click();
              ev.preventDefault();
            }
          }}
        />
        <IconButton
          aria-label="input"
          ref={buttonRef}
          onClick={onEnter}
          size="small"
        >
          <SendIcon ic="" />
        </IconButton>
      </span>
    </>
  );
};

export default MathInput;


